/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
// import React, { useContext, useEffect, useState } from 'react'
// import { FormContext } from '../Component/Forms/FormContext';
// import {InputLabel} from '@material-ui/core';
// // import  useStyles  from '../Component/Theme_1/FormControlsCss';
// import ThemeControls from "../Component/AllThemesControl";
// import copy from "copy-to-clipboard";  
// import axios from 'axios';
// import Button from './Button';
// import FormControl from '@mui/material/FormControl';
// import logo from "../images/customerconsent.png";
// import {APIUPLOAD}            from '../services/APIServices';
// import { MdOutlineFileUpload, MdOutlineDone} from "react-icons/md";
// import *as XLSX from 'xlsx';
// import FormHelperText from '@mui/material/FormHelperText';



// function UploadFileExcel(props) {
//   const {useStyle} = ThemeControls;
//   const classes = useStyle();
//   const [file, setFile] = useState()
//   const [uploadPercentage, setUploadPercentage] = useState();
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [headers, setheader] = useState(null);
//   const [row, setRow] = useState(null);
//   const [disable, setDisable] = useState(true);
//   const [filename, setFilename] = useState(null);
//   const [fileFormat, setFileFormat] = useState('');
//   const [copyText, setCopyText] = useState('');
//   const [error, seterror] = useState('');
  
//   let { id,field_type, field_id,field_apipath,field_disabled,preview,field_label,acceptfile,required_column, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory } = props;
//   const { handleChange } = useContext(FormContext)
//   const apipath= "uploadFiles/uploadFile";
//   const fileType=acceptfile;
// //console.log(acceptfile)

//   function getFileExtension(filename) {
//     const Extension = filename.split('.').pop();
//     setFileFormat(Extension)
//   }

//   const handleChangeFile = async (event) => {
//     if (event.target.files && event.target.files.length > 0) {
//       setFile(event.target.files[0])
//       const efile=event.target.files[0];
//       //console.log(efile.name)
//       const data= await efile.arrayBuffer(efile);
//       const excelFile=XLSX.read(data,{type:'buffer'});
//       const excelSheet=excelFile.Sheets[excelFile.SheetNames[0]];
//       const exceljson=XLSX.utils.sheet_to_json(excelSheet);
//       setRow(exceljson.length)
//       setFilename(efile.name)
//       setUploadedFile(null);
//      const fileCol = Object.keys(exceljson[0]);
//       getFileExtension(efile.name)
//     if(efile&&fileType.includes(efile.type)){
//       const isValidHeader = fileCol.some(element => required_column.includes(element.toLowerCase()));
//       if(isValidHeader){
//         setheader(Object.keys(exceljson[0]))
//         setDisable(false)
//         seterror('')
//         // alert('ok file')
//       }else{
//         setDisable(true)
//         setheader(Object.keys(exceljson[0]))
//         seterror('The header fields must have following name: MSISDN, Email')
//       }
//     }else{
//           setDisable(true)
//           setheader(null)
//           seterror('Please select following files:.csv, .xlsx')
//       } 
//     }
//   }
// //   const onSubmit = async e => {
// //     e.preventDefault();
// //     const formData = new FormData();
// //     formData.append('file', file);
// //     let token = localStorage.getItem("token");
// //     let _authorization = `Bearer ${token}`;
// //     try {
// //       // const res = await UploadFile('uploadFiles/uploadFile', formData, {
// //       const res = await axios.post(apipath, formData, {
// //         headers: {
// //           'Content-Type': 'multipart/form-data',
// //           'token':token,
// //           'authorization':_authorization,
// //           "Access-Control-Allow-Origin": "http://localhost:3000,*",
// //         },
// //         onUploadProgress: progressEvent => {
// //           setUploadPercentage(
// //             parseInt(
// //               Math.round((progressEvent.loaded * 100) / progressEvent.total)
// //             )
// //           );
// //         }
// //       });
 
// //      // Clear percentage
// //      setTimeout(() => setUploadPercentage(), 1000);

// //      const { fileName,uploadFilesLabel,filePath } = res.data.data;
// //     // alert(uploadFilesLabel);
// //     handleChange(field_id,fileFormat,uploadFilesLabel);
// //      setUploadedFile(uploadFilesLabel);
// //      setCopyText(filePath);
// //     //  setMessage('File Uploaded');
// //    } catch (err) {
// //      if (err.response.status === 500) {
// //       alert('There was a problem with the server');
// //       //  setMessage('There was a problem with the server');
// //      } else {
// //       //  setMessage(err.response.data.msg);
// //      }
// //      setUploadPercentage()
// //    }
// //  };

//  function setFileData(data){
//   //console.log(data)
//   const { fileName,uploadFilesLabel,filePath } = data;
//   handleChange(field_id,fileFormat,uploadFilesLabel);
//    setUploadedFile({ fileName, filePath });
//    setCopyText(filePath);
// }


//  const onSubmit = async (e) => {
//   e.preventDefault();
//   const formData = new FormData();
//   formData.append('file', file);

//   try {
//     const response = await APIUPLOAD(apipath, formData, setUploadPercentage, setFileData);
 
//   } catch (error) {
//     console.error('Error uploading file:', error);
//   }
// };

//  const copyToClipboard = () => {
//   copy(copyText);
//   alert(`You have copied "${copyText}"`);
// }
//   return (
// <div className={classes.fileroot}>
// <div style={{display:"flex"}}>
//         <InputLabel style={props.field_label_style?props.field_label_style:null} className={props.field_label_class?classes[props.field_label_class]:classes.label}  >{field_label}</InputLabel>{field_mandatory==="yes"?<span 
//           style={{fontSize: "18px",
//           color: "#d71729",
//           fontWeight: "400",
//           lineHeight: "20px",
//           transform: "translateY(-2px)"}}>*</span>:null}
//       </div>
//     <div className={classes.fubox}>
//          <InputLabel className={classes.label}>Upload</InputLabel>
//          <div className={classes.alinfilebtn}>
//          <div  variant="outlined" className={classes.upldfl}>
//          {filename?<label for="files">{filename}</label>:<label for="files">Upload file only in .xlxs, .csv</label>}
//             <input type="file" 
//             id="files"
//             onChange={handleChangeFile} 
//             accept={acceptfile}
//             />
//             {/* <button type="button" onClick={copyToClipboard}>Copy Url</button>: */}

//           {uploadPercentage && (<div className={classes.progress}>
//           <div
//             className={classes.progressBar}
//             role='progressbar'
//             style={{ width: `${uploadPercentage}%` }}
//           >
//               {uploadPercentage}%
//             </div>
//           </div>)}
//           </div>
//           <button type="submit"  onClick={onSubmit} disabled={disable}><MdOutlineFileUpload /></button>
//          </div>

//       {headers && (<div className={classes.fileheader}>
//       <InputLabel className={classes.label}>Preview</InputLabel>
//       <table className={classes.headerview}>
//         <thead>
//           <tr>
//             {headers.map((item, index) => {
//           return (
//             <th key={index}>{item}</th>
//             )})}
//           </tr>
//         </thead>
//       </table>
//       </div>)}
//         {error&&<FormHelperText>{error}</FormHelperText>}
//         {uploadedFile&&(<div class={classes.done}><span><MdOutlineDone /></span><p>{row} Rows has been successfully Upload</p></div>)}
  
//     </div>
      
//   </div>
//   );
// }

// export default UploadFileExcel;


// import React, { useContext, useEffect, useState } from 'react'
// import { FormContext } from '../Component/Forms/FormContext';
// import {InputLabel} from '@material-ui/core';
// // import  useStyles  from '../Component/Theme_1/FormControlsCss';
// import ThemeControls from "../Component/AllThemesControl";
// import { MdOutlineFileUpload, MdOutlineDone} from "react-icons/md";
// import *as XLSX from 'xlsx';
// import FormHelperText from '@mui/material/FormHelperText';



// function UploadFileExcel(props) {
//   const {useStyle} = ThemeControls;
//   const classes = useStyle();
//   const [file, setFile] = useState()
//   const [uploadPercentage, setUploadPercentage] = useState();
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [headers, setheader] = useState(null);
//   const [row, setRow] = useState(null);
//   const [disable, setDisable] = useState(true);
//   const [filename, setFilename] = useState(null);
//   const [fileFormat, setFileFormat] = useState('');
//   const [copyText, setCopyText] = useState('');
//   const [error, seterror] = useState('');
  
//   let { id,field_type, field_id,field_apipath,field_disabled,preview,field_label,acceptfile,required_column, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory } = props;
//   const { handleChange } = useContext(FormContext)
//   const apipath= "uploadFiles/uploadFile";
//   const fileType=acceptfile;
// //console.log(acceptfile)

//   function getFileExtension(filename) {
//     const Extension = filename.split('.').pop();
//     setFileFormat(Extension)
//   }

//   const handleChangeFile = async (event) => {
//     if (event.target.files && event.target.files.length > 0) {
//       setFile(event.target.files[0])
//       const efile=event.target.files[0];
//       //console.log(efile.name)
//       const data= await efile.arrayBuffer(efile);
//       const excelFile=XLSX.read(data,{type:'buffer'});
//       const excelSheet=excelFile.Sheets[excelFile.SheetNames[0]];
//       const exceljson=XLSX.utils.sheet_to_json(excelSheet);
//       setRow(exceljson.length)
//       setFilename(efile.name)
//       setUploadedFile(null);
//      const fileCol = Object.keys(exceljson[0]);
//       getFileExtension(efile.name)
//     if(efile&&fileType.includes(efile.type)){
//       // const isValidHeader = fileCol.some(element => required_column.includes(element.toLowerCase()));
//       const isValidHeader = required_column.every(element => fileCol.some(col => col.toLowerCase() === element.toLowerCase()));
//       if(isValidHeader){
//         setheader(Object.keys(exceljson[0]))
//         setDisable(false)
//         seterror('')
//         const formData = new FormData();
//         formData.append('file', efile);
//         handleChange(field_id,{},efile);
        
//       }else{
//         setDisable(true)
//         setheader(Object.keys(exceljson[0]))
//         handleChange(field_id,{},'');
//         seterror(`The header fields must have following name: ${required_column.join(', ')}`)
//       }
//     }else{
//           setDisable(true)
//           setheader(null)
//           seterror('Please select following files:.xls')
//       } 
//     }
//   }

//   return (
// <div className={classes.fileroot}>
//         <div className={classes.fubox}>
//          {/* <InputLabel className={classes.label}>{field_label}</InputLabel> */}
//          <div style={{display:"flex"}}>
//         <InputLabel style={props.field_label_style?props.field_label_style:null} className={props.field_label_class?classes[props.field_label_class]:classes.label}  >{field_label}</InputLabel>{field_mandatory==="yes"?<span 
//           style={{fontSize: "18px",
//           color: "#d71729",
//           fontWeight: "400",
//           lineHeight: "20px",
//           transform: "translateY(-2px)"}}>*</span>:null}
//       </div>
//          <div className={classes.alinfilebtn}>
//          <div  variant="outlined" className={classes.upldfl}>
//          {filename?<label for="files">{filename}</label>:<label for="files">{field_placeholder}</label>}
//             <input type="file" 
//             id={field_id}
//             onChange={handleChangeFile} 
//             accept={acceptfile}
//             />
//             {/* <button type="button" onClick={copyToClipboard}>Copy Url</button>: */}

//           {uploadPercentage && (<div className={classes.progress}>
//           <div
//             className={classes.progressBar}
//             role='progressbar'
//             style={{ width: `${uploadPercentage}%`}}
//           >
//               {uploadPercentage}%
//             </div> 
//           </div>)}
//           </div>
//           {/* <button type="submit"  onClick={onSubmit} disabled={disable}><MdOutlineFileUpload /></button> */}
//          </div>

//       {headers && (<div className={classes.fileheader}>
//       <InputLabel className={classes.label}>Preview</InputLabel>
//       <table className={classes.headerview}>
//         <thead>
//           <tr>
//             {headers.map((item, index) => {
//           return (
//             <th key={index}>{item}</th>
//             )})}
//           </tr>
//         </thead>
//       </table>
//       </div>)}
//         {error&&<FormHelperText>{error}</FormHelperText>}
//         {row&&(<div class={classes.done}><span><MdOutlineDone /></span><p> Your file contains {row} rows of data.</p></div>)}
  
//     </div>
      
//   </div>
//   );
// }

// export default UploadFileExcel;



// import React, { useContext, useState } from 'react';
// import { FixedSizeList as List } from 'react-window';
// import { FormContext } from '../Component/Forms/FormContext';
// import { InputLabel } from '@material-ui/core';
// import ThemeControls from "../Component/AllThemesControl";
// import { MdOutlineFileUpload, MdOutlineDone } from "react-icons/md";
// import * as XLSX from 'xlsx';
// import FormHelperText from '@mui/material/FormHelperText';

// function UploadFileExcel(props) {
//   const { useStyle } = ThemeControls;
//   const classes = useStyle();
//   const [file, setFile] = useState();
//   const [uploadPercentage, setUploadPercentage] = useState();
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [headers, setHeaders] = useState(null);
//   const [rows, setRows] = useState([]);
//   const [disable, setDisable] = useState(true);
//   const [filename, setFilename] = useState(null);
//   const [fileFormat, setFileFormat] = useState('');
//   const [error, setError] = useState('');

//   let { id, field_type, field_id, field_apipath, field_disabled, preview, field_label, acceptfile, required_column, field_placeholder, field_value, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory } = props;
//   const { handleChange } = useContext(FormContext);
//   const fileType=acceptfile;
//   function getFileExtension(filename) {
//     const Extension = filename.split('.').pop();
//     setFileFormat(Extension);
//   }

//   const handleChangeFile = async (event) => {
//     if (event.target.files && event.target.files.length > 0) {
//       setFile(event.target.files[0]);
//       const efile = event.target.files[0];
//       const data = await efile.arrayBuffer(efile);
//       const excelFile = XLSX.read(data, { type: 'buffer' });
//       const excelSheet = excelFile.Sheets[excelFile.SheetNames[0]];
//       const excelJson = XLSX.utils.sheet_to_json(excelSheet);

//       if (excelJson.length === 0) {
//         setError('The uploaded file is empty or contains no readable data.');
//         return;
//       }

//       setRows(excelJson);
//       setFilename(efile.name);
//       setUploadedFile(null);
//       const fileCol = Object.keys(excelJson[0] || {});
//       getFileExtension(efile.name);

//       if (efile && fileType.includes(efile.type)) {
//         const isValidHeader = required_column.every(element => fileCol.some(col => col.toLowerCase() === element.toLowerCase()));
//         if (isValidHeader) {
//           setHeaders(fileCol);
//           setDisable(false);
//           setError('');
//           const formData = new FormData();
//           formData.append('file', efile);
//           handleChange(field_id, {}, efile);
//         } else {
//           setDisable(true);
//           setHeaders(fileCol);
//           handleChange(field_id, {}, '');
//           setError(`The header fields must have the following names: ${required_column.join(', ')}`);
//         }
//       } else {
//         setDisable(true);
//         setHeaders(null);
//         setError('Please select a valid file: .xls or .xlsx');
//       }
//     }
//   };

//   const Row = ({ index, style }) => (
//     <tr style={style}>
//       {headers.map((header, colIndex) => (
//         <td key={colIndex} className={classes.tableCell}>{rows[index][header]}</td>
//       ))}
//     </tr>
//   );

//   return (
//     <div className={classes.fileroot}>
//       <div className={classes.fubox}>
//         <div style={{ display: "flex" }}>
//           <InputLabel style={props.field_label_style ? props.field_label_style : null} className={props.field_label_class ? classes[props.field_label_class] : classes.label}>{field_label}</InputLabel>
//           {field_mandatory === "yes" && <span style={{
//             fontSize: "18px",
//             color: "#d71729",
//             fontWeight: "400",
//             lineHeight: "20px",
//             transform: "translateY(-2px)"
//           }}>*</span>}
//         </div>
//         <div className={classes.alinfilebtn}>
//           <div variant="outlined" className={classes.upldfl}>
//             {filename ? <label htmlFor="files">{filename}</label> : <label htmlFor="files">{field_placeholder}</label>}
//             <input
//               type="file"
//               id={field_id}
//               onChange={handleChangeFile}
//               accept={acceptfile}
//             />
//             {uploadPercentage && (<div className={classes.progress}>
//               <div
//                 className={classes.progressBar}
//                 role='progressbar'
//                 style={{ width: `${uploadPercentage}%` }}
//               >
//                 {uploadPercentage}%
//               </div>
//             </div>)}
//           </div>
//         </div>

//         {headers && rows.length > 0 && (
//           <div className={classes.fileheader}>
//             <InputLabel className={classes.label}>Preview</InputLabel>
//             <table className={classes.headerview}>
//               <thead>
//                 <tr>
//                   {headers.map((item, index) => (
//                     <th key={index}>{item}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 <List
//                   height={400}
//                   itemCount={rows.length}
//                   itemSize={35}
//                   width={"100%"}
//                 >
//                   {Row}
//                 </List>
//               </tbody>
//             </table>
//           </div>
//         )}

//         {error && <FormHelperText>{error}</FormHelperText>}
//         {rows.length > 0 && (
//           <div className={classes.done}>
//             <span><MdOutlineDone /></span>
//             <p>Your file contains {rows.length} rows of data.</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UploadFileExcel;


import React, { useContext, useState, useMemo } from 'react';
import { FormContext } from '../Component/Forms/FormContext';
import { InputLabel, Button, CircularProgress } from '@material-ui/core';
import ThemeControls from "../Component/AllThemesControl";
import { MdOutlineFileUpload, MdOutlineDone } from "react-icons/md";
import * as XLSX from 'xlsx';
import FormHelperText from '@mui/material/FormHelperText';
import TablePagination from '@mui/material/TablePagination';
// import SampleFile from '../modules/RateSheet/ManualRateSheet/sampleRateSheet.xls'
function UploadFileExcel(props) {
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  const [file, setFile] = useState();
  const [uploadPercentage, setUploadPercentage] = useState();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [headers, setHeaders] = useState(null);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // Change currentPage initial value to 0
  const [rowsPerPage, setRowsPerPage] = useState(10); // Initial rows per page value
  const [disable, setDisable] = useState(true);
  const [filename, setFilename] = useState(null);
  const [fileFormat, setFileFormat] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  let { id, field_type, field_id, field_apipath, field_disabled, preview, field_label, acceptfile, required_column, field_placeholder, field_value, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory } = props;
  const { handleChange } = useContext(FormContext);
  const fileType=acceptfile;
  function getFileExtension(filename) {
    const Extension = filename.split('.').pop();
    setFileFormat(Extension);
  }

  const handleChangeFile = async (event) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
      const efile = event.target.files[0];
      const data = await efile.arrayBuffer(efile);
      const excelFile = XLSX.read(data, { type: 'buffer' });
      const excelSheet = excelFile.Sheets[excelFile.SheetNames[0]];
      const excelJson = XLSX.utils.sheet_to_json(excelSheet);
      setFilename(efile.name);
      if (excelJson.length === 0) {
        setRows([])
        setError('The uploaded file is empty or contains no readable data.');
        return;
      }

      setRows(excelJson);
      setUploadedFile(null);
      const fileCol = Object.keys(excelJson[0] || {});
      getFileExtension(efile.name);

      if (efile && fileType.includes(efile.type)) {
        const isValidHeader = required_column.every(element => fileCol.some(col => col === element));
        if (isValidHeader) {
          setHeaders(fileCol);
          setDisable(false);
          setError('');

          // const isValidDateFormat = excelJson.every(row => {
          //   const effectiveDate = row['EffectiveDate (MM/dd/yyyy)'];
          //   console.log('EffectiveDate value:', effectiveDate);
          //   return /^\d{2}\/\d{2}\/\d{4}$/.test(effectiveDate);
          // });
  
          // if (isValidDateFormat) {
          //   setError('The date format in the "EffectiveDate" column is incorrect.');
          //   return;
          // }

          const formData = new FormData();
          formData.append('file', efile);
          handleChange(field_id, {}, efile);
        } else {
          setDisable(true);
          setHeaders(fileCol);
          handleChange(field_id, {}, '');
          setError(`The header fields must have the following names: ${required_column.join(', ')}`);
        }
      } else {
        setDisable(true);
        setHeaders(null);
        setError('Please select a valid file: .xls or .xlsx');
      }
    }
  };

  // Memoize rows rendering for performance optimization
  const memoizedRows = useMemo(() => rows.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage), [rows, currentPage, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset current page to 0 when rows per page changes
  };

  return (
    <div className={classes.fileroot}>
      <div className={classes.fubox}>
        <div style={{ display: "flex" }}>
          <InputLabel style={props.field_label_style ? props.field_label_style : null} className={props.field_label_class ? classes[props.field_label_class] : classes.label}>{field_label}</InputLabel>
          {field_mandatory === "yes" && <span style={{
            fontSize: "18px",
            color: "#d71729",
            fontWeight: "400",
            lineHeight: "20px",
            transform: "translateY(-2px)"
          }}>*</span>}
        </div>
        <div className={classes.alinfilebtn}>
          <div variant="outlined" className={classes.upldfl}>
            {filename ? <label htmlFor="files">{filename}</label> : <label htmlFor="files">{field_placeholder}</label>}
            <input
              type="file"
              id={field_id}
              onChange={handleChangeFile}
              accept={acceptfile}
            />
            {uploadPercentage && (<div className={classes.progress}>
              <div
                className={classes.progressBar}
                role='progressbar'
                style={{ width: `${uploadPercentage}%` }}
              >
                {uploadPercentage}%
              </div>
            </div>)}
          </div>
          
        <a href='' download><button>Sample File</button></a>
        </div>
        {error && <FormHelperText>{error}</FormHelperText>}
        
        {headers && memoizedRows.length > 0 && (
          <div className={classes.fileheader}>
            <div className={classes.alinfilebtn}>
            <InputLabel className={classes.label}>Preview</InputLabel>
            {rows.length > 0 && (
          <div className={classes.done}>
            {/* <span><MdOutlineDone /></span> */}
            <p>Your file contains {rows.length} rows of data.</p>
          </div>
        )}
            </div>

            <table className={classes.headerview}>
              <thead>
                <tr>
                  {headers.map((item, index) => (
                    <th key={index} className={classes.tableHeader}>{item}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {memoizedRows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.map((header, colIndex) => (
                      <td key={colIndex} className={classes.tableCell}  style={{
                        color:
                          header === "EffectiveDate (MM/dd/yyyy)" && !/^\d{2}\/\d{2}\/\d{4}$/.test(row[header])
                            ? 'red'
                            : 'inherit',
                      }}>{row[header]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
{/* {loading && <CircularProgress className={classes.loadingIndicator} />} */}
{rows.length > rowsPerPage && (
          <div className={classes.pagination}>
            <TablePagination
              component="div"
              labelRowsPerPage='Show rows per page'
              count={rows.length}
              page={currentPage}
              onPageChange={handlePageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 50, 100, 500]}
              showFirstButton
              showLastButton
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default UploadFileExcel;
